var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3241_1948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.1375C13.305 5.1375 14.3625 6.195 14.3625 7.5C14.3625 8.805 13.305 9.8625 12 9.8625C10.695 9.8625 9.6375 8.805 9.6375 7.5C9.6375 6.195 10.695 5.1375 12 5.1375ZM12 15.2625C15.3413 15.2625 18.8625 16.905 18.8625 17.625V18.8625H5.1375V17.625C5.1375 16.905 8.65875 15.2625 12 15.2625ZM12 3C9.51375 3 7.5 5.01375 7.5 7.5C7.5 9.98625 9.51375 12 12 12C14.4863 12 16.5 9.98625 16.5 7.5C16.5 5.01375 14.4863 3 12 3ZM12 13.125C8.99625 13.125 3 14.6325 3 17.625V19.875C3 20.4938 3.50625 21 4.125 21H19.875C20.4938 21 21 20.4938 21 19.875V17.625C21 14.6325 15.0038 13.125 12 13.125Z",
    fill: "white",
    stroke: "#85593E",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57857 12.5714V10.5786H6.57143C6.88999 10.5786 7.15 10.3186 7.15 10C7.15 9.68144 6.88999 9.42143 6.57143 9.42143H4.57857V7.42857C4.57857 7.11001 4.31856 6.85 4 6.85C3.68144 6.85 3.42143 7.11001 3.42143 7.42857V9.42143H1.42857C1.11001 9.42143 0.85 9.68144 0.85 10C0.85 10.3186 1.11001 10.5786 1.42857 10.5786H3.42143L3.42143 12.5714C3.42143 12.89 3.68144 13.15 4 13.15C4.31856 13.15 4.57857 12.89 4.57857 12.5714Z",
    fill: "white",
    stroke: "#85593E",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3241_1948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserWhite);
export default __webpack_public_path__ + "static/media/add-user-white.fd60547ba9eb82b05ed67af4824cc95f.svg";
export { ForwardRef as ReactComponent };